/**
 * Standard request headers for a Firebase Cloud Function call.
 *
 * Centralises the header object that was previously inlined at every call site
 * so the build version travels with every Firebase request:
 *  - `Content-Type: application/json`
 *  - `Authorization: Bearer <idToken>` (the caller still mints/refreshes the token)
 *  - `X-Client-Version`: the frontend build id (`VITE_CACHE_VERSION`, injected at
 *    build), so the function side can record which build issued the request —
 *    the same signal `getApiSecurityHeaders()` stamps on FastAPI calls.
 *
 * Pure function of the token: callers keep their own auth-retry / response
 * handling, they only swap their inline `{ 'Content-Type', Authorization }`
 * literal for this.
 */
export function firebaseFunctionHeaders(
  idToken: string,
): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
    'X-Client-Version':
      (import.meta.env.VITE_CACHE_VERSION as string | undefined) || '1.0.0',
  };
}
